export const stylesCP = {
  container: {
    minHeight: "100%",
    background: "#fff",
    padding: "24px 20px 32px 20px",
    overflowY: "scroll",
    scrollBehavior: "smooth",
  },
  title: {
    fontFamily: "RobotoBold",
    fontSize: "16px",
    margin: "0px 0px 24px 0px",
    color: "#50626c",
    textAlign: "center",
  },
  formWrapper: {
    boxShadow: "0px 0px 30px 0px #26012024",
    padding: "24px 20px 32px 20px",
    borderRadius: "8px",
  },
  termsWrapper: {
    display: "inline-grid",
    columnGap: "14px",
    gridTemplateColumns: "auto auto",
    alignItems: "center",
    margin: "32px 0px 32px 0px",
  },
  termsTextWrapper: {
    textAlign: "justify",
    lineHeight: "20px",
  },
  termsText: {
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#0f0f0f",
  },
  termsTextLink: {
    fontFamily: "RobotoBold",
    fontSize: "12px",
    color: "#0f0f0f",
    textDecoration: "underline",
  },
  termsIframe: {
    border: "none",
    width: "100%",
    minHeight: "100%",
    overflowY: "scroll",
  },
  textSubtitle: {
    fontFamily: "RobotoBold",
    fontSize: "12px",
    color: "#0f0f0f",
    display: "block",
  },
  textPhoneNumber: {
    fontFamily: "RobotoRegular",
    fontSize: "14px",
    color: "#848484",
  },
  phoneNumber: {
    fontFamily: "RobotoRegular",
    fontSize: "12px",
    color: "#474747",
  },
  imgBillTelcel: {
    width: "100%",
    verticalAlign: "bottom",
  },
  subtitleWrapper: {
    display: "inline-grid",
    columnGap: "14px",
    gridTemplateColumns: "20% 80%",
    alignItems: "center",
    margin: "0px 0px 24px 0px",
  },
  subtitle: {
    margin: "0px 0px",
  },
  buttonWrapper: {
    textAlign: "center",
  },
  inputDateWrapper: {
    margin: "24px 0px 0px 0px",
  },
  inputContent: {
    position: "relative",
  },
};
